import script from "./my-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./my-menu.vue?vue&type=script&setup=true&lang=js"

import "./my-menu.vue?vue&type=style&index=0&id=835d131e&lang=css"
import "./my-menu.vue?vue&type=style&index=1&id=835d131e&lang=scss&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-835d131e"]])

export default __exports__